<template>
    <div class="page-container" :class="{'has-breadcrumb': profile.isSharpAdmin()}">
        <div v-if="profile.isSharpAdmin()" class="px-8 md:px-5 py-5 ">
            <breadcrumb></breadcrumb>
        </div>

        <div class="px-8 md:px-5 py-5 ">
            <h1 v-if="isAdding" class="mb-6">
                Add User
            </h1>
            <h1 v-else class="mb-6">
                Edit User
            </h1>

            <div>
                <user-form :userID="$route.params.userID" :clientID="clientID" ></user-form>
            </div>
        </div>
    </div>
</template>

<script charset="utf-8">
    import Vuex from 'vuex';
    import UserForm from './form/UserForm.vue';
    import Breadcrumb from './includes/Breadcrumb.vue';

    export default {
        components: {
            UserForm,
            Breadcrumb
        },

        created: function () {
            let text = 'Add User';
            if(this.$router.currentRoute.value.params.userID){
                text = 'Edit User';
            }

            this.getClient({ clientID: this.clientID}).then(client => {
                this.setPaths([
                    {
                        text: 'Sharp Admin',
                        name: 'adminClients'
                    },
                    {
                        text: client.name,
                        name: 'adminUser',
                        params: { clientID: client.id }
                    },
                    {
                        text: 'Users',
                        name: 'adminUser',
                        params: { clientID: client.id }
                    },
                    {
                        text: text,
                        isText: true
                    }
                ]);
            });
        },

        computed: {
            ...Vuex.mapGetters('profile', {
                profile: 'profile'
            }),

            isAdding: function () {
                return !this.$router.currentRoute.value.params.userID;
            },
            clientID: function () {
                if(this.profile.isSharpAdmin() || this.profile.isGroupAdmin()){
                    return this.$route.params.clientID;
                }else{
                    return this.profile.getUser().client_id;
                }
            }
        },

        methods: {
            ...Vuex.mapActions('accounts', {
                getClient: 'getClient'
            }),
            ...Vuex.mapMutations('layout', {
                setPaths: 'setPaths',
            })
        }
    }
</script>
